var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.UserInfo && _vm.UserInfo.UserBranch == 'company')?_c('HQHome'):(_vm.UserInfo && _vm.UserInfo.UserBranch !== 'company')?_c('ProductsComp',{attrs:{"User":_vm.UserInfo}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }